import { toImageUrl } from "@/shared/utils/imageUrl";

interface ItemThumbnailProps {
  /** 저장소 상대 경로 또는 절대 URL */
  path?: string | null;
  alt: string;
  className?: string;
}

/** 품목 사진 썸네일. 사진이 없으면 빈 자리표시자를 보여준다. */
export const ItemThumbnail = ({
  path,
  alt,
  className = "size-12",
}: ItemThumbnailProps) =>
  path ? (
    // 외부(API/Blob) 출처 이미지라 next/image 최적화 대상에서 제외
    // eslint-disable-next-line @next/next/no-img-element
    <img
      src={toImageUrl(path)}
      alt={alt}
      className={`${className} shrink-0 rounded-md border object-cover`}
    />
  ) : (
    <div
      className={`${className} flex shrink-0 items-center justify-center rounded-md border bg-muted text-[10px] text-muted-foreground`}
    >
      사진 없음
    </div>
  );
